import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';
import {getUUID} from '../../../../utils/getUUID';
import CustomButton from '../button-cell/custom-button';

export default class CarouselCell extends BaseCell {

  render() {
    const {carousels} = this.props;
    return (
      <div className={'cu-ui-carousel'}>
        <div className={'cu-ui-carousel-slides'}>
          {
            _.map(carousels, (c) => {
              return <Carousel title={c.title} explain={c.explain} buttons={c.buttons} key={getUUID()}></Carousel>
            })
          }
        </div>
      </div>
    )
  }
}


function Carousel({title, explain, buttons}) {
  return (
    <div className={'cu-ui-carousel-slide'}>
      <div className={'cu-ui-carousel-image'}>
        <div className={'cu-ui-carousel-placeholder'}></div>
      </div>
      <div className={'cu-ui-carousel-text'}>
        <h5 className={'title'}>
          {title}
        </h5>
        {explain}
      </div>
      <div className={'cu-ui-carousel-buttons'}>
        {
          _.map(buttons, (b) => {
            return <CustomButton button={b} buttonType={'carousel'} key={getUUID()}/>;
          })
        }
      </div>
    </div>
  )
}

CarouselCell.propTypes = {
  carousels: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/chat-body/chat-cells/carousel-cell/index.jsx